import { Sutl } from '../../../../sutl';
export function convertChannels(channels) {
    return Sutl.arrayToObj(channels, 'a');
}
export function convertDetected(detected) {
    const converted = {};
    if (detected.channels)
        converted.channels = convertChannels(detected.channels);
    if (detected.devices)
        converted.devices = convertDevices(detected.devices);
    if (detected.videoInputs)
        converted.videoInputs = convertVideoInputs(detected.videoInputs);
    if (detected.videoOutputs)
        converted.videoOutputs = convertVideoOutputs(detected.videoOutputs);
    return converted;
}
export function convertDevices(devices) {
    return Sutl.arrayToObj(devices, 'a');
}
export function convertVideoInputs(inputs) {
    return Object.fromEntries(inputs.map(input => [Sutl.sanitizeId(input.code), input]));
}
export function convertVideoOutputs(outputs) {
    return Object.fromEntries(outputs.map(output => [Sutl.sanitizeId(output.code), output]));
}
